export enum CoreApiVersionPath {
    V3 = 'v3/',
    V4 = 'v4/',
    V5 = 'v5/'
}
